import { render, staticRenderFns } from "./BodyExpensesAnalysis.vue?vue&type=template&id=32c42a19&scoped=true"
import script from "./BodyExpensesAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyExpensesAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodyExpensesAnalysis.vue?vue&type=style&index=0&id=32c42a19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c42a19",
  null
  
)

export default component.exports